import Vue from 'vue'
const Bus = new Vue()

export default new Vue({
  el: '#app',
  data: {
    Bus
  }
})



// WEBPACK FOOTER //
// ./src/lib/bus.js